/**
 * Created by piotr.pozniak@thebeaverhead.com on 13/11/2024
 */

import React, { useContext } from "react";
import RowModal from "./EventsList/RowModal";
import { useCalendarStore } from "../../../hooks/redux/calendar";
import CalendarLinkingContext from "../../../contexts/CalendarLinkingContext";
import useQuery from "../../../hooks/useQuery";
import useSubscribePopup from "../hooks/useSubscribePopup";
import OGData from "./OGData";

/**
 *
 * @param {Boolean} embedded - Whetner it's embedded in the website/app or used in the builder
 * @returns {Element}
 * @constructor
 */
const SelectedEventModal = ({ embedded }) => {
  const { calendar } = useCalendarStore();
  const {
    getEventUrl,
    selectedEvent,
    showDetailsAsModal,
    expandDetailsAsAccordion,
    showHighlightsDetailsAsModalValue,
    pillsOpenDetailsAsModal,
  } = useContext(CalendarLinkingContext);

  const query = useQuery();
  const selectorToScroll = query.has("selector") ? query.get("selector") : null;
  const isHighlight = query.has("highlights");

  const { subscribePopup } = useSubscribePopup({
    eventName: selectedEvent?.name,
    integrationUUID: calendar.model.integration.uuid,
    widgetUUID: calendar.model.uuid,
    ICSID: selectedEvent?.ics_id,
  });

  const modalEvent =
    (selectedEvent && (showDetailsAsModal || pillsOpenDetailsAsModal)) ||
    (selectedEvent && isHighlight && showHighlightsDetailsAsModalValue) ? (
      <>
        <OGData
          title={selectedEvent.name}
          description={selectedEvent.description}
          image={selectedEvent.cover_image}
          seoSettings={calendar.model.widget_settings.seo || {}}
          url={getEventUrl(selectedEvent)}
        />
        {subscribePopup}
        <RowModal
          event={selectedEvent}
          showDetails={true}
          calendarSlug={calendar.model.slug}
          embedded={embedded}
          loading={
            calendar.rsvp ||
            calendar.fetch ||
            calendar.delete ||
            calendar.update
          }
          error={calendar.rsvpError}
          expandedRowSlug={selectedEvent.slug}
          expandAsAccordion={expandDetailsAsAccordion}
          expandAsModal={showDetailsAsModal}
          calendarID={`dce_calendar__${calendar.model.uuid}`}
          showWatermark={calendar?.model?.is_watermarked}
          onOpenScrollToSelector={selectorToScroll}
          calendarUUID={calendar.model.uuid}
        />
      </>
    ) : null;

  return modalEvent;
};

export default SelectedEventModal;
